import {
  Col,
  FormGroup,
  Label,
  Row,
  Card,
  CardTitle,
  CardBody,
  Button,
  InputGroup,
} from "reactstrap";
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CustomSelect from "./../../Common/CustomSelect";
import InvoiceItems from "./InvoiceItems";
import CustomMultipleDateRange from "../../CustomMultipleDateRange/CustomMultipleDateRange";
import CheckboxCollapse from '../../Common/CheckboxCollapse';
import { AvField } from "availity-reactstrap-validation";
import styled from "styled-components";
import Select from "react-select";

const InvoiceCustom = props => {
  const generateKey = () => Math.round(Math.random() * 10000).toString();

  const [groups, setGroups] = React.useState([
    { key: generateKey(), serviceName: "", quantity: "", sum: "" },
  ]);

  const [client, setClient] = React.useState(null);
  const [bank, setBank] = React.useState(null);
  const [currentSelectedClient, setSelectedClient] = React.useState("");
  const [currentSelectedBank, setSelectedBank] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState({});
  const [selectedCurrency, setSelectedCurrency] = React.useState("");
  const [isVoucherCurrency, setIsVoucherCurrency] = React.useState(false);
  const [payMethod, setPayMethod] = React.useState("");
  const [language, setLanguage] = React.useState("");

  React.useEffect(() => {
    return () => {
      setClient(null);
      setBank(null);
      setSelectedDate({});
    };
  }, []);

  React.useEffect(() => {
    if (client?.id !== undefined) {
      onChangeClient(client.id);
    }
    if (bank?.id !== undefined) {
      onChangeBank(bank.id);
    }
  }, [props.contractors, props.legal_entity]);

  const handleAddGroup = () => {
    setGroups(prev => [
      ...prev,
      { key: generateKey(), serviceName: "", quantity: "", sum: "" },
    ]);
  };

  const handleDeleteGroup = key => {
    setGroups(prev => prev.filter(i => i.key !== key));
  };

  const onChangeClient = id => {
    if (id !== undefined) {
      const { contractors } = props;
      let selectedClient = contractors.results.find(client => client.id === id);
      setSelectedClient({
        label: selectedClient.counterparty_name,
        value: selectedClient.id,
      });

      if (id !== undefined) {
        setClient(selectedClient);
        props.onChangeSelected("client", id);
      }
    }
  };

  const onChangeBank = id => {
    if (id !== undefined) {
      const { legal_entity } = props;
      let selectedBank = legal_entity.results.find(bank => bank.id === id);
      setSelectedBank({
        label: selectedBank.counterparty_name,
        value: selectedBank.id,
      });
      if (id !== undefined) {
        setBank(selectedBank);
        props.onChangeSelected("bank", id);
      }
    }
  };

  const choicesArray = (choice_type, doubleKey) => {
    let arr = [];
    if (choice_type !== undefined) {
      for (let [key, value] of Object.entries(choice_type)) {
        arr.push({
          label: doubleKey ? key : value,
          value: key,
        });
      }
    }
    return arr;
  };

  const client_options = React.useMemo(
    () =>
      props.contractors?.results.map(item => ({
        label: item?.counterparty_name + ' ' + `[ ${item?.date_of_signature} ]`,
        value: item?.id,
        // value: item?.inner_contractor?.id
      })),
    [props.contractors]
  );

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">Custom</CardTitle>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Client:</Label>
                <CustomSelect
                  name={"client"}
                  options={client_options}
                  placeholder="Select client..."
                  defaultValue={currentSelectedClient || ""}
                  onChange={e => onChangeClient(e.value)}
                  required
                  classNamePrefix="select2-selection"
                  errorMessage="Client is required!"
                  isFormSubmit={props.isFormSubmit}
                />
              </FormGroup>
            </Col>
            {/* <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Bank:</Label>
                <CustomSelect
                  name={"bank"}
                  options={props.legal_entity?.results.map(item => {
                    return {
                      label: item.counterparty_name,
                      value: item.id,
                    };
                  })}
                  defaultValue={currentSelectedBank || ""}
                  placeholder="Select bank..."
                  onChange={e => onChangeBank(e.value)}
                  required
                  classNamePrefix="select2-selection"
                  errorMessage="Client is required!"
                  isFormSubmit={props.isFormSubmit}
                />
              </FormGroup>
            </Col> */}
          </Row>
          <Row id="information-client-bank" className="mb-3">
            <Col md={6}>
              {client !== null && (
                <Col
                  md={12}
                  id="info-client"
                  className="fade-in-custom-animate text-muted"
                >
                  <Row style={{ userSelect: "none" }}>
                    <Col
                      md={12}
                      className="mt-2 mb-2"
                      style={{ fontWeight: "600" }}
                    >
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div>
                          <span>{client?.counterparty_name || "Empty"}</span>
                        </div>
                        <div>
                          <EditDataStyled
                            className="bx bx-pencil font-size-18 mw-2 float-end"
                            onClick={() =>
                              props.toggleViewEditInvoiceModal("client", client)
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ userSelect: "none" }}>
                    <Col md={6} className="mb-2">
                      email: {client?.customer_email || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      city: {client?.customer_city || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      street: {client?.customer_street || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      country: {client?.customer_country || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      zip: {client?.postal_address || "Empty"}
                    </Col>

                    {/* <Col md={12} className="mb-2">
                      Address: {client?.legal_address || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      City: {client?.customer_city || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Street: {client?.customer_street || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Country: {client?.customer_country || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Zip: {client?.postal_address || "Empty"}
                    </Col> */}
                  </Row>
                </Col>
              )}
            </Col>
            <Col md={6}>
              {bank !== null && (
                <Col
                  md={12}
                  id="info-bank"
                  className="fade-in-custom-animate text-muted float-right"
                >
                  <Row style={{ userSelect: "none" }}>
                    <Col
                      md={12}
                      className="mt-2 mb-2"
                      style={{ fontWeight: "600" }}
                    >
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div>
                          <span>{bank?.counterparty_name || "Empty"}</span>
                        </div>
                        <div>
                          <EditDataStyled
                            className="bx bx-pencil font-size-18 mw-2 float-end"
                            onClick={() =>
                              props.toggleViewEditInvoiceModal("bank", bank)
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ userSelect: "none" }}>
                    <Col md={6} className="mb-2">
                      street: {bank?.bank_street || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      country: {bank?.bank_country || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      zip: {bank?.postal_address || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      iban: {bank?.bank_iban || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      city: {bank?.bank_city || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      swift: {bank?.swift || "Empty"}
                    </Col>
                    {/* <Col md={12} className="mb-2">
                      Bank name: {bank?.bank_name || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Bank address: {bank?.bank_address || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Account No. {bank?.settlement_account || "Empty"}
                    </Col>
                    <Col md={12} className="mb-2">
                      Swift Code: {bank?.swift || "Empty"}
                    </Col>
                    <Col md={6} className="mb-2">
                      City: {bank?.bank_city || "Empty"}
                    </Col> */}
                  </Row>
                </Col>
              )}
            </Col>
          </Row>
          <CardTitle className="h4 mb-3">Items</CardTitle>
          <Row>
            <Col md={12}>
              {groups.map((i, idx) => (
                <InvoiceItems
                  key={idx}
                  num={groups.length}
                  keys={i.key}
                  onDelete={
                    groups.length > 1 ? () => handleDeleteGroup(i.key) : null
                  }
                />
              ))}
              <Row>
                <div className="text-end my-0 mt-3">
                  <Button color="primary" onClick={handleAddGroup}>
                    <i className="mdi mdi-plus" /> Add items
                  </Button>
                </div>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Language:</Label>
                <CustomSelect
                  name={"language"}
                  options={choicesArray(props.choices?.language, false)}
                  placeholder="Select language"
                  classNamePrefix="select2-selection"
                  errorMessage="Language field is required"
                  isFormSubmit={props.isFormSubmit}
                  onChange={setLanguage}
                  defaultValue={language}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              {/* <FormGroup className="mb-3">
                <Label htmlFor="">Currency:</Label>
                <CustomSelect
                  name="currency"
                  options={choicesArray(props.choices?.currency, true)}
                  placeholder="Select currency"
                  classNamePrefix="select2-selection"
                  errorMessage="Currency field is required"
                  isFormSubmit={props.isFormSubmit}
                  defaultValue={selectedCurrency}
                  onChange={setSelectedCurrency}
                  required
                />
              </FormGroup> */}
              <FormGroup className="mb-3">
                <PickerStyled>
                  <Label htmlFor="">Date due:</Label>
                  <CustomMultipleDateRange
                    placeholder="Select date due..."
                    name="date_due"
                    datePickerType={"calendar"}
                    onChange={date => setSelectedDate(date)}
                    errorText="Date due is required!"
                    required
                  />
                </PickerStyled>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Payment method:</Label>
                <CustomSelect
                  name="payment_method"
                  options={choicesArray(props.choices?.payment_method)}
                  placeholder="Select payment method"
                  classNamePrefix="select2-selection"
                  errorMessage="Countries field is required"
                  isFormSubmit={props.isFormSubmit}
                  onChange={setPayMethod}
                  defaultValue={payMethod}
                  required
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup className="mb-3">
                <CheckboxCollapse
                  id={"voucher-currency-value"}
                  title="Currency"
                  defaultChecked={isVoucherCurrency}
                  onChange={() => setIsVoucherCurrency(!isVoucherCurrency)}
                  style={{
                    marginBottom: 10,
                  }}
                >
                  {isVoucherCurrency && (
                    <Row>
                      <Col sm={6}>
                        <AvField
                          name={`currency_value`}
                          placeholder="Currency value..."
                          type="number"
                          className="form-control"
                        />
                      </Col>
                      <Col sm={6}>
                        <CustomSelect
                          name="currency"
                          options={choicesArray(props.choices?.currency, true)}
                          placeholder="Currency..."
                          classNamePrefix="select2-selection"
                          errorMessage="Currency field is required"
                          defaultValue={selectedCurrency}
                          onChange={setSelectedCurrency}
                        />
                      </Col>
                    </Row>
                  )}
                </CheckboxCollapse>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

const EditDataStyled = styled.i`
  cursor: pointer;
  transition-duration: 0.5s;
  &:hover {
    color: #2684ff;
    transition-duration: 0.5s;
  }
`;

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

InvoiceCustom.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  clients: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  contractors: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  legal_entity: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  client: PropTypes.object.isRequired,
  choices: PropTypes.object.isRequired,
  isFormSubmit: PropTypes.bool.isRequired,
  onGetClientById: PropTypes.func.isRequired,
  setClient: PropTypes.func.isRequired,
  toggleViewEditInvoiceModal: PropTypes.func.isRequired,
  onChangeSelected: PropTypes.func.isRequired,
};

export default InvoiceCustom;
